import { Box } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { useSelectionContext } from "../../../../context/SelectionContext";
import { useIsFeatureFlagEnabled } from "../../../../featureFlags/useIsFeatureFlagEnabled";
import { InboundTab } from "../../InboundLayout";
import { ErrorContainer } from "../AccordionWithContentAndActionBar";
import { ClearSidebarSelection } from "../ClearSidebarSelection";
import { Appointments } from "./Appointments";
import { OSAD } from "./Osad";
import { PlannedRoutesAndTraps } from "./PlannedRoutesAndTraps";
import { Traps } from "./Traps";
import { UnassignedShipments } from "./UnassignedShipments";

export interface SidebarRef {
  refresh: () => void;
  clearSelection: () => void;
}

type SidebarContentProps = {
  tab: InboundTab;
};

const ErrorFallback = () => <ErrorContainer title="Error when fetching" />;

export const SidebarContent = ({ tab }: SidebarContentProps) => {
  const isOsadFeatureEnabled = useIsFeatureFlagEnabled(
    "operations-5834-inbound-osad-client"
  );

  const { selected } = useSelectionContext();

  const isAnySelected =
    selected.reduce((total, item) => total + item.shipmentIds.length, 0) > 0;

  return (
    <Box
      sx={{
        position: "relative",
        paddingX: "1rem",
        marginBottom: isAnySelected ? "180px" : "unset",
      }}
    >
      {tab === "planning" && (
        <>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <UnassignedShipments />
          </ErrorBoundary>
          <PlannedRoutesAndTraps />
          {isOsadFeatureEnabled && <OSAD />}
        </>
      )}
      {tab === "pre-planning" && (
        <>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Traps />
          </ErrorBoundary>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Appointments />
          </ErrorBoundary>
          {isAnySelected && <ClearSidebarSelection />}
        </>
      )}
    </Box>
  );
};
